<div [formGroup]="form">
  <mat-form-field appearance="outline" [class]="question.settings && question.settings.size">
    <input
      matInput
      type="text"
      [placeholder]="question.settings && question.settings.placeholder"
      [formControlName]="question.key"
      [id]="question.key"
      [matAutocomplete]="autoComplete"
      position="below"
      #autoCompleteInput="matAutocompleteTrigger"
    >

    <mat-autocomplete autoActiveFirstOption #autoComplete="matAutocomplete" [displayWith]="displaySelectedItem">
      <mat-option *ngIf="loading" value='' disabled>
        {{ (question.settings && question.settings.loading_text) ? question.settings.loading_text : 'Loading...' }}
      </mat-option>
      <mat-option *ngIf="loadingError" value='' disabled>
        {{ (question.settings && question.settings.error_text) ? question.settings.error_text : 'Error loading details' }}
      </mat-option>
      <mat-option *ngIf="!loading && !loadingError && searchText.length >= 3 && options.length === 0" value='' disabled>
        {{ (question.settings && question.settings.no_results_text) ? question.settings.no_results_text : 'Not able to find the details' }}
      </mat-option>
      <mat-option *ngFor="let option of options; index as i;" [value]="option" (onSelectionChange)="onOptionSelect()" [class]="question.key + '-mat-option-'+ i">
        {{ option.label }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
 